import React from 'react';
import { Box, Button, Container, Typography } from '@mui/material';
import { BlackVideo } from '../../assets/img';
import { BackgroundElement } from './elements';
import textMaskElement from '../../assets/img/mobileLanding/text-mask-ele.png'
import useDevice from 'hooks/useDevice';
import CallBackSection from './CallBackSection';

function AboutSection({ type }: { type: 'web' | 'mobile' }) {
  const { screenWidth } = useDevice();
  const isWeb = type === 'web';

  return (
    <Box
      component="section"
      sx={{
        position: 'relative',
        display: 'block',
        backgroundColor: '#000',
        pt: 20,
        zIndex: 0,
      }}
    >
      <Container
        maxWidth={isWeb ? "xl" : "md"}
        sx={isWeb ? {
          px: 2,
          pb: 0,
          height: 'auto',
          display: "flex",
          position: "relative",
          mb: 36
        } : {
          px: 2,
          pb: 0,
          height: 'auto',
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Box
          sx={
            isWeb ? {
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'flex-start',
              textAlign: 'left',
              flexDirection: 'column',
              spacing: 2,
              width: 'fit-content',
              maxWidth: "430px",
              position: "absolute",
              top: 0,
              zIndex: 10,
            } : {
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'center',
              textAlign: 'center',
              flexDirection: 'column',
              spacing: 2,
              width: '100%',
              maxWidth: "430px",
            }}
        >
          <Typography
            variant='caption'
            sx={{
              color: 'white',
              fontSize: '20px',
              position: "relative",
              width: "fit-content",
              margin: isWeb ? "0" : "auto"
            }}
            className='font-indie'
            title="Custom Software Development Company Kerala"
          >
            We develop enterprise
            <BackgroundElement
              sx={{
                top: '-5rem',
                right: '-2rem',
              }}
            />
          </Typography>
          <Typography
            variant="h1"
            className='font-satoshi-black'
            title="Custom Software Development & ERP NEXT Company in Kerala"
            sx={{
              fontSize: '52px',
              fontWeight: 700,
              background: 'linear-gradient(180deg, #3A8CF7 0%, #2861FF 74.06%, #223F91 120.52%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
              textTransform: 'capitalize',
              lineHeight: 1.2,
              position: 'relative',
              width: "fit-content",
              margin: isWeb ? "0" : "auto",
              mb: 2
            }}
          >
            {isWeb ? (
              <>
                Custom Software  <br /> & Systems
              </>
            ) : (
              <>
                Custom <br />
                Software & <br /> Systems
              </>
            )}
            <BackgroundElement
              sx={{
                bottom: '-100px',
                left: '-85px',
              }}
            />
          </Typography>

          <Typography
            variant="body1"
            className='font-satoshi-medium'
            title="Business Management Software Kerala"
            sx={{
              color: 'white',
              fontSize: isWeb ? '24px' : '18px',
              position: 'relative',
              width: 'fit-content',
              margin: isWeb ? '0' : 'auto',
            }}
          >
            that optimize your businesses
            <br />
            and make it truly{' '}
            <Box
              component="span"
              sx={{
                position: 'relative',
                display: 'inline-block',
                color: "black",
                zIndex: 1,
              }}
            >
              tech‑driven.
              <Box
                component="img"
                src={textMaskElement}
                alt="Business Automation Software Kerala"
                title="Business Automation Software Kerala"
                sx={{
                  position: 'absolute',
                  top: '0px',
                  left: '-4px',
                  width: '100%',
                  height: 'auto',
                  zIndex: -1,
                  minWidth: "110px"
                }}
              />
            </Box>
          </Typography>

          {isWeb &&
            <CallBackSection type={type} />
          }
        </Box>

        <Box
          sx={{
            perspective: isWeb ? '900px' : '300px',
            zIndex: 5,
            width: isWeb ? '60%' : { xs: '100%', sm: '70%' },
            height: 'auto',
            pt: 0,
            pb: screenWidth < 330 ? 3 : 9,
            ...(isWeb ? { ml: 'auto', mt: 10 } : { mx: 'auto' }),
          }}
        >
          <Box
            component="video"
            loop
            autoPlay
            muted
            preload="auto"
            playsInline
            sx={{
              pointerEvents: 'none',
              mt: 6, // 3rem
              width: '100%',
              margin: "auto",
              height: { xs: '80%', sm: 'auto' },
              borderRadius: '1.3rem',
              transform: isWeb
                ? 'rotateX(10deg) rotateY(-55deg) rotateZ(5deg)'
                : 'rotateX(33deg)',
              boxShadow: isWeb
                ? '0 20px 50px rgba(0,0,0,0.8), 0 0 20px rgba(58, 140, 247, 0.2)'
                : 'none',
              border: isWeb ? '1.5px solid rgba(255, 255, 255, 0.1)' : 'none',
              objectFit: { xs: 'cover', sm: 'initial' },
              objectPosition: "left"
            }}
          >
            <source src={BlackVideo} type="video/mp4" />
          </Box>
        </Box>
      </Container >
    </Box >
  );
}

export default AboutSection;
